import { render, staticRenderFns } from "./Cursos.vue?vue&type=template&id=b06bdaf4&scoped=true"
import script from "./Cursos.vue?vue&type=script&lang=js"
export * from "./Cursos.vue?vue&type=script&lang=js"
import style0 from "./Cursos.vue?vue&type=style&index=0&id=b06bdaf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06bdaf4",
  null
  
)

export default component.exports